import React from 'react';
type SectionHeadingProps = {
  eyebrow?: string;
  title: string;
  subtitle?: string;
  align?: 'center' | 'left';
};
export function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = 'center'
}: SectionHeadingProps) {
  const alignment = align === 'center' ? 'text-center mx-auto' : 'text-left';
  return <div className={`max-w-2xl ${alignment}`} data-id="element-144" data-mp="3k186xwdgxaex">
      {eyebrow ? <p className="font-display text-sm font-bold uppercase tracking-wide text-lilac-400" data-id="element-145" data-mp="bkn8vamdk1ql">
          {eyebrow}
        </p> : null}
      <h2 className="mt-2 font-display text-3xl font-extrabold leading-tight text-ink sm:text-4xl" data-id="element-146" data-mp="gi58gaei54lx">
        {title}
      </h2>
      {subtitle ? <p className="mt-3 text-base leading-relaxed text-ink/70 sm:text-lg" data-id="element-147" data-mp="6tn97xlvf5ke">{subtitle}</p> : null}
    </div>;
}